import { buildCustomFieldDefaults, toFormAddress } from "components/BaseForm";

export const FORM_MODES = {
  create: "create",
  edit: "edit",
};

const fromRecord = record => ({
  name: record.name ?? "",
  urls: record.urls ?? [],
  account_managers: (record.account_managers ?? []).map(
    ({ user_id }) => user_id
  ),
  external_cc_emails: record.external_cc_emails ?? "",
  region_id: record.region_id ?? null,
  country: record.country ?? null,
  addresses: (record.addresses ?? []).map(address =>
    toFormAddress(address, record.primary_address_id)
  ),
  alternate_names: (record.alternate_names ?? []).map(({ name }) => name),
  tags: record.tags ?? [],
});

const BLANK_ENTITY = {
  name: "",
  urls: [],
  account_managers: [],
  external_cc_emails: "",
  region_id: null,
  country: null,
  addresses: [],
  alternate_names: [],
  tags: [],
};

/** Initial form values for each mode. */
export const buildDefaultValues = ({ mode, record, customFieldConfigs }) =>
  mode === FORM_MODES.edit
    ? {
        ...fromRecord(record),
        custom_fields: buildCustomFieldDefaults(
          customFieldConfigs,
          record.custom_fields
        ),
      }
    : {
        ...BLANK_ENTITY,
        custom_fields: buildCustomFieldDefaults(customFieldConfigs, null),
      };
